import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { QueryFnContextProvider } from '@twiliointernal/org-twilio-platform-query-fn-context';
import { ReactElement } from 'react';
import { AppQueryFunctionsProvider } from '../queryFunctionsProvider';

import { constants, types } from './definitions';

export const queryClient = new QueryClient({
  defaultOptions: constants.defaultOptions,
});

export const AppQueriesProvider = ({
  children,
}: types.AppQueriesProviderProps): ReactElement<types.AppQueriesProviderProps> => {
  return (
    <QueryClientProvider client={queryClient}>
      <QueryFnContextProvider>
        <AppQueryFunctionsProvider>{children}</AppQueryFunctionsProvider>
      </QueryFnContextProvider>
    </QueryClientProvider>
  );
};
